import React, { Suspense, useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom';
import ResumesListing from './dashboard/ResumesListing';
import { connect } from 'react-redux';
import CoverLettersListing from './dashboard/CoverLettersListing';
import Cookie from 'js-cookie';
import { CHOOSE_COLOR, COOKIE_DOMAIN, DASHBOARD_LINK, APP_DOMAIN } from '../constants/constants';
import CallOutBanner from './dashboard/CallOutBanner';
import TransitionBanner from './common/TransitionBanner';
import { Redirect } from 'react-router';
import { canProceedWithResumeAction } from '../utils/resumeLimitCheck';
const Dashboard = (props) => {
  const entityName = "Resume";
  const [tab, setTab] = useState(null);
  const mounted = useRef(false);
  const [createAction, setCreateAction] = useState(false);
  const [resumeCount,setResumeCount] = useState();
  const [showGreetingMessage,setShowGreetingMessage] = useState(null);
  const [btnCreateVisible, setBtnCreateVisible] = useState(true);
  const showcaseRef = useRef(null);
  const reactHistory = useHistory();
  useEffect(() => {
      //browser issue, page not opening at top
      window.scrollTo(0, 0)
      mounted.current = true;
      return () => {
          mounted.current = false;
      };
  }, []);
  
  useEffect(() => {
    if(tab === null ) toggleTab(Cookie.get('dashboard_tab', { domain: COOKIE_DOMAIN, path: "/" }) ?? 'resume') 
  }, []);

  
  const toggleTab = (t) => {
    setTab(t);
    Cookie.set('dashboard_tab', t, {domain: COOKIE_DOMAIN, path: "/"});
  }

  const offlineResumesDoNotExist = () => {
    // Check for offline resume existance
    return (localStorage.getItem('offlineResumes') != null && JSON.parse(localStorage.getItem('offlineResumes')).length == 0) || (localStorage.getItem('offlineResumes') == null)
  }

  useEffect(()=>{
    if((Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"}) && !resumeCount) || (!Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"}) && offlineResumesDoNotExist())){
      setShowGreetingMessage('Get Started Now');
    } else {
      setShowGreetingMessage('Resume.org Dashboard');
    }    
  },[resumeCount]);
  
  useEffect(() => {
    const resumes = JSON.parse(localStorage.getItem('resumes')) || {};
    const isResumesEmpty = Object.keys(resumes).length === 0;
    // Show or hide the button based on conditions
    if (isResumesEmpty) {
      setBtnCreateVisible(false);
    }else if (!isResumesEmpty) {
      setBtnCreateVisible(true);
    } 
  });

  if (createAction) {
    // Use safe navigation instead of direct pushState
    try {
      reactHistory.push(DASHBOARD_LINK);
    } catch (error) {
      console.warn('Navigation error, using fallback:', error.message);
      window.location.href = CHOOSE_COLOR;
      return null;
    }
    return <Redirect to={CHOOSE_COLOR} />
  }

  return <>
  <div className={`deshboard-screen ${!btnCreateVisible ? 'no-resume-screen':''}`}>
    <div className="container">

          <div className="create-resume-btn-mobile " onClick={() => {
              // Check resume limit before creating
              if (!canProceedWithResumeAction('create')) {
                return;
              }
              gaTrack('RB App', 'Dashboard', `Create a New ${entityName}`);
              ga4Track('app_dashboard_create_button_mobile', 'RB App', `Create a New ${entityName} Mobile`);
              setCreateAction(true);
            }}>
            <span>+ Create New {entityName}</span>
          </div>

        <div className="deshboard-head">
          <div className='welcome-block'><h1>{showGreetingMessage != null ? showGreetingMessage : ''} </h1>
            {(Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"}) && props.user !== null) && <div className="head-user">Welcome back{props.user.firstname != '' ? `, ${props.user.firstname} ${props.user.lastname}` : ''}!</div>
            }
          </div>
          <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            {props.user?.capabilities?.administrator && btnCreateVisible && (
            <div className="create-resume-btn-dashboard" onClick={() => showcaseRef.current?.()}
              style={{ cursor: 'pointer' }}>
              <span>Generate Showcase</span>
            </div>)}
            {btnCreateVisible && (
            <div className="create-resume-btn-dashboard " onClick={() => {
                if (!canProceedWithResumeAction('create')) {
                  return;
                }
                gaTrack('RB App', 'Dashboard', `Create a New ${entityName}`);
                ga4Track('app_dashboard_create_button_mobile', 'RB App', `Create a New ${entityName} Mobile`);
                setCreateAction(true);
              }}>
              <span>+ Create New {entityName}</span>
            </div>)}
          </div>
          {/* <div className="head-user">Welcome back, John Doe!</div> */}
        </div>
        {/* <CallOutBanner /> */}
        {/* <TransitionBanner dashboardUrl={`${APP_DOMAIN}/`} /> */}

      <div className="deshboard-tab-outer">
        {/* <div className="tabs">
          <span id = 'resumetab' className={tab == 'resume' ? 'active' : ""} onClick={()=>toggleTab('resume')}>Resumes</span> 
          <span id = 'lettertab'className={tab == 'coverletter' ? 'active' : ""} onClick={()=>toggleTab('coverletter')}>Cover Letter</span>
        </div> */}
        <div className="tab-panel">
          {/* {tab == null && 'Loading...'} */}
          {tab == 'resume'  &&  <ResumesListing setResumeCount={(resumeCount)=>setResumeCount(resumeCount)} showcaseRef={showcaseRef} {...props} />}
          {/* {tab == 'coverletter'  &&  <CoverLettersListing {...props} />} */}
        </div>
      </div>
     </div>
  </div>
  </>
 
}

export default connect(state => state)(Dashboard);